<div class="radar-chart" [attr.aria-labelledby]="'chart' + chartId">
  <div [id]="'chart' + chartId" class="hidden-aria-labels">
    <span>{{ 'translations.assessmentReportChartTitle' | transloco }}</span>
    <span *ngFor="let title of chartDataLabels; index as i">
      {{ 'translations.assessmentReportChartItem' | transloco }} {{ title }}, {{ 'translations.assessmentReportChartScore' | transloco }}
      {{ chartData[0].data[i] }}.
    </span>
  </div>

  <div class="chart-preview">
    <div class="radar-chart-container">
      <canvas #Chart baseChart [datasets]="chartData" [labels]="chartLabels" [type]="'radar'" [options]="chartOptions"></canvas>

      <button
        class="custom-label"
        [class.is-active]="activeLabelIndex === i"
        role="button"
        tabindex="0"
        (click)="togglePopup(i)"
        (keyup.enter)="togglePopup(i)"
        *ngFor="let item of chartDataLabels; index as i"
        [ngStyle]="{
          left: item.left + 'px',
          top: item.top + 'px',
          transform: item.transform,
        }"
      >
        <div class="custom-label-inner small bold">
          {{ item.label }}
        </div>
        <div class="scores-popup" [class.active]="activeLabelIndex === i" *ngIf="item.feedbackProviderTagScores?.length">
          <div class="scores-popup-inner">
            <div class="score-item" *ngIf="includeSelfFeedback">
              <div class="icon-box user-box" [style.background-color]="userResultColor(0.3)">User</div>
              <div class="name small">{{ 'translations.selfRating' | transloco }}</div>
              <div class="score hover-reveal" [style.background-color]="userResultColor(0.3)" tabindex="0">
                <span class="percent">{{ item.userScorePercent | number: '1.0-0' }}%</span>
                <span class="raw" aria-hidden="true">{{ item.userRawScore | number: '1.0-0' }} / {{ item.userMaxScore }}</span>
              </div>
            </div>

            <div class="scores-divider with-label">{{ 'translations.diagnostics.feedbackStats.evaluators' | transloco }}</div>

            <div class="score-item">
              <div class="icon-box" [style.background-color]="providerResultColor(0.3)">AVG</div>
              <div class="name small">{{ 'translations.evaluatorAvgRating' | transloco }}</div>
              <div class="score hover-reveal" [style.background-color]="providerResultColor(0.3)" tabindex="0">
                <span class="percent"> {{ item.allFeedbackProvidersAvgScore | number: '1.0-0' }}% </span>
                <span class="raw" aria-hidden="true"> {{ item.avgRawScore | number: '1.0-0' }} / {{ item.totalPossible }} </span>
              </div>
            </div>

            <div class="score-item" *ngFor="let feedback of item.feedbackProviderTagScores">
              <div class="icon-box">
                <img [src]="feedback.providerImage" alt="{{ feedback.providerName }}" *ngIf="feedback.providerImage" />
              </div>
              <div class="name small">{{ feedback.providerName }}</div>
              <div class="score hover-reveal" tabindex="0">
                <span class="percent">{{ (feedback.tagScore * 100) / item.totalPossible | number: '1.0-0' }}%</span>
                <span class="raw" aria-hidden="true">{{ feedback.tagScore | number: '1.0-0' }} / {{ item.totalPossible }}</span>
              </div>
            </div>
          </div>
        </div>
      </button>
    </div>

    <div class="chart-legend">
      <div class="legend-item" *ngIf="includeSelfFeedback">
        <span class="legend-color" [style.background]="userResultColor()"></span>
        <span class="legend-label">{{ 'translations.selfRating' | transloco }}</span>
      </div>
      <div class="legend-item">
        <span class="legend-color" [style.background]="providerResultColor()"></span>
        <span class="legend-label">{{ 'translations.evaluatorAvgRating' | transloco }}</span>
      </div>
    </div>
  </div>
</div>
